

export function SubmenuComponent() {
    for (let submenuComponent of document.querySelectorAll('.submenu')) {
        let submenu = submenuComponent.querySelector('ul');
        let previous = submenuComponent.querySelector('.previous');
        let next = submenuComponent.querySelector('.next');
        previous.addEventListener('click', function() {
            submenu.scrollTo({ left: 0, behavior: 'smooth' });
            next.removeAttribute('hidden');
            previous.setAttribute('hidden', 'hidden');
        });
        next.addEventListener('click', function() {
            console.log(submenu.offsetWidth, submenu.scrollWidth);
            if (submenu.scrollWidth <= submenu.offsetWidth*2) {
                submenu.scrollTo({ left: submenu.scrollWidth - submenu.offsetWidth, behavior: 'smooth' });
                /*previous.removeAttribute('hidden');
                next.setAttribute('hidden', 'hidden');*/
            }
            else {
                let navigationItem = submenu.querySelector('a');
                submenu.scrollTo({ left: submenu.scrollLeft + navigationItem.offsetWidth, behavior: 'smooth' });
                /*if (submenu.scrollLeft + navigationItem.offsetWidth > submenu.scrollWidth - submenu.offsetWidth - navigationItem.offsetWidth / 2) {
                    next.setAttribute('hidden', 'hidden');
                    previous.removeAttribute('hidden');
                }*/
            }
        });
        let scrollLeft = submenu.scrollLeft;
        submenu.addEventListener('scroll', function(event) {
            let navigationItem = submenu.querySelector('a');
            if (scrollLeft < submenu.scrollLeft) {
                if (submenu.scrollLeft > submenu.scrollWidth - submenu.offsetWidth - navigationItem.offsetWidth / 2) {
                    next.setAttribute('hidden', 'hidden');
                    previous.removeAttribute('hidden');
                }
            }
            else {
                if (submenu.scrollLeft < navigationItem.offsetWidth / 2) {
                    previous.setAttribute('hidden', 'hidden');
                    next.removeAttribute('hidden');
                }
            }
            scrollLeft = submenu.scrollLeft;
        });
        /*function Scroll() {
            let navigationItem = submenu.querySelector('a');
            if (submenu.scrollLeft < navigationItem.offsetWidth / 2) {
                previous.setAttribute('hidden', 'hidden');
            }
            else {
                previous.removeAttribute('hidden');
            }
            if (submenu.scrollLeft > submenu.scrollWidth - submenu.offsetWidth - navigationItem.offsetWidth / 2) {
                next.setAttribute('hidden', 'hidden');
            }
            else {
                next.removeAttribute('hidden');
            }
        }
        submenu.addEventListener('scroll', Scroll);
        Scroll();*/
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', SubmenuComponent);
}
else {
    SubmenuComponent();
}

